import i18n from "../localization/i18n";
import { mmFromSceneUnits } from "./scaler";

const MM_PER_CM = 10;

// What a drag is setting, as reported by the dragged object's data class. The label is a resource
// key rather than text so the model layer stays out of localization; the caller composes the two.
export interface DragMeasurement {
    labelKey?: string; // omitted when the value speaks for itself, e.g. "120 × 80 cm"
    text: string; // formatted value including its unit
}

// Whole centimetres: this readout sits under a moving cursor, and finer precision would make the
// trailing digits churn every frame. The properties panel remains the precise view.
// Math.round keeps the sign, so a flipped (negative) extrusion depth reads as such.
export const cmValue = (sceneUnits: number): number =>
    Math.round(mmFromSceneUnits(sceneUnits) / MM_PER_CM);

export const formatCm = (sceneUnits: number): string => `${cmValue(sceneUnits)} cm`;

export function dragMeasurementText(measurement: DragMeasurement | undefined): string | undefined {
    if (!measurement) return undefined;

    return measurement.labelKey
        ? `${i18n.t(measurement.labelKey)} ${measurement.text}`
        : measurement.text;
}
